module.exports = __webpack_public_path__ + "static/media/galerija_2019 (36).fbb18a1c.jpg";